import { useTranslation } from 'react-i18next';

import Button from '@/components/common/Button';
import ChatBubble from '@/features/compose/components/ChatBubble';

type Props = {
  onRetry: () => Promise<void> | void;
};

export default function ConceptReplyError({ onRetry }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <ChatBubble from="assistant">
        <p className="text-destructive">{t('CONCEPT_REPLY_FAILED')}</p>
      </ChatBubble>

      <Button
        className="self-start"
        variant="secondary"
        size="sm"
        onSubmit={onRetry}
      >
        {t('RETRY')}
      </Button>
    </>
  );
}
